import React from 'react'
import { PostHogProvider } from 'posthog-js/react'
import { PostHogConfig } from 'posthog-js'
import { AudioProvider } from './podcast/audio/AudioProvider'

const options: Partial<PostHogConfig> = {
  api_host: 'https://eu.i.posthog.com',
}
const RootElement = ({ children }: React.PropsWithChildren) => {
  const posthogApiKey = process.env.GATSBY_POSTHOG_KEY as string

  return (
    <PostHogProvider options={options} apiKey={posthogApiKey}>
      <AudioProvider>{children}</AudioProvider>
    </PostHogProvider>
  )
}

export default RootElement
